module.exports = __webpack_public_path__ + "img/realtimenav.48bd2b6c.png";